export default "__VITE_ASSET__DRvoZtuJ__"